import { createStyles } from '@material-ui/core';
export var switchStyles = function (theme) {
    return createStyles({
        root: {
            width: '52px',
            height: '32px',
            padding: 0,
            margin: theme.spacing(1),
            '& + .MuiFormControlLabel-label': {
                color: theme.palette.text.primary,
            },
        },
        switchBase: {
            padding: theme.spacing(0.25),
            '&$checked': {
                transform: "translateX(" + theme.spacing(2.5) + "px)",
                color: theme.palette.common.white,
                '& + $track': {
                    backgroundColor: theme.palette.primary.main,
                    opacity: 1,
                    border: 'none',
                },
            },
        },
        thumb: {
            width: '28px',
            height: '28px',
        },
        track: {
            borderRadius: 16,
            backgroundColor: theme.palette.text.secondary,
            opacity: '60%',
            transition: theme.transitions.create(['background-color', 'border']),
        },
        checked: {},
    });
};
